module.exports = __webpack_public_path__ + "static/img/exe.b36ffdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons-actividad/exe.png
// module id = 216
// module chunks = 1